import { Instagram, Facebook } from "lucide-react";
import { RESTAURANT } from "@/data/restaurant";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1a1815] text-white/80 py-12 px-4 sm:px-6 lg:px-8"
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <div className="flex items-center gap-2">
            <span className="inline-block w-9 h-9 rounded-full bg-[#D9534F] text-white grid place-items-center font-display font-extrabold">
              M
            </span>
            <span className="font-display text-xl font-extrabold text-white">
              Meritz Restaurant
            </span>
          </div>
          <p className="mt-3 text-sm max-w-sm">
            &ldquo;{RESTAURANT.tagline}&rdquo; — made fresh daily in {RESTAURANT.address}.
          </p>
        </div>

        <div className="flex flex-col md:items-end gap-3 text-sm">
          <div className="flex items-center gap-3">
            <a
              href={RESTAURANT.socials.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              aria-label="Instagram"
              className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#D9534F] grid place-items-center transition-colors"
            >
              <Instagram size={16} />
            </a>
            <a
              href={RESTAURANT.socials.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              aria-label="Facebook"
              className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#D9534F] grid place-items-center transition-colors"
            >
              <Facebook size={16} />
            </a>
          </div>
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} Meritz Restaurant. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
